import {TagIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

import {LABELS} from './constants/labels'

const getTitle = (isArchivedView: boolean, noLabelsCreated: boolean) => {
  if (isArchivedView) {
    return LABELS.noArchivedLabelsTitle
  }
  if (noLabelsCreated) {
    return LABELS.noLabelsCreatedTitle
  }
  return LABELS.noMatchingLabelsTitle
}

const getDescription = (isArchivedView: boolean, noLabelsCreated: boolean, viewerCanPush: boolean) => {
  if (isArchivedView) {
    return LABELS.noArchivedLabelsDescription
  }
  if (noLabelsCreated && viewerCanPush) {
    return LABELS.noLabelsCreatedDescription
  }
  return LABELS.noMatchingLabelsDescription
}

export const EmptyState = ({
  noLabelsCreated,
  viewerCanPush,
  onCreateLabel,
  isArchivedView = false,
}: {
  noLabelsCreated: boolean
  viewerCanPush: boolean
  onCreateLabel?: () => void
  isArchivedView?: boolean
}) => {
  return (
    <Blankslate>
      <Blankslate.Visual>
        <TagIcon size="medium" />
      </Blankslate.Visual>
      <Blankslate.Heading as="h3">{getTitle(isArchivedView, noLabelsCreated)}</Blankslate.Heading>
      <Blankslate.Description>{getDescription(isArchivedView, noLabelsCreated, viewerCanPush)}</Blankslate.Description>
      {noLabelsCreated && viewerCanPush && !isArchivedView && (
        <Blankslate.PrimaryAction onClick={onCreateLabel}>{LABELS.newLabel}</Blankslate.PrimaryAction>
      )}
    </Blankslate>
  )
}
